<div class="lg-scrollable">
    <div
        lgScrollable
        lgScrollableAutoHide="true"
        [lgScrollableWrapper]="false"
        #content
        #scrollable
    >
        <div class="lg-quick-settings-menu-popup__group" *ngFor="let group of _popupGroups">
            <div
                class="lg-quick-settings-menu-popup__group-title"
                *ngIf="group.name"
                [lgTooltip]="_hideTooltipIcons && group.help ? group.help : null"
                [lgTooltipDelay]="_hideTooltipIcons && group.help ? '500, 0' : null"
                lgTooltipPosition="right-bottom"
            >
                {{ group.name }}
                <lg-icon
                    icon="icon-help"
                    class="lg-quick-settings-menu-popup__group-help"
                    *ngIf="!_hideTooltipIcons && group.help"
                    [lgTooltip]="group.help"
                    [lgTooltipOptions]="{ delayShow: 0, delayHide: 0 }"
                    lgTooltipPosition="right-bottom"
                ></lg-icon>
            </div>
            <ng-container *ngFor="let item of group.items">
                <div
                    *ngIf="item !== 'separator'"
                    class="lg-quick-settings-menu-popup__item"
                    [ngClass]="{
                        'lg-quick-settings-menu-popup__item--submenu': item.isSubmenu,
                        'lg-quick-settings-menu-popup__item--expanded': item === _expandedItem,
                        'lg-quick-settings-menu-popup__item--path': item.index === _pathIndex,
                        'lg-quick-settings-menu-popup__item--cursor': item.index === _cursorIndex
                    }"
                    [lgTooltip]="_hideTooltipIcons && item.help ? item.help : null"
                    [lgTooltipDelay]="_hideTooltipIcons && item.help ? '500, 0' : null"
                    lgTooltipPosition="right-bottom"
                    (mouseenter)="_hoverItem($event, item)"
                    (click)="_itemClick(item)"
                >
                    <span>
                        {{ item.name }}
                        <lg-icon
                            icon="icon-help"
                            class="lg-quick-settings-menu-popup__item-help"
                            *ngIf="!_hideTooltipIcons && item.help"
                            [lgTooltip]="item.help"
                            [lgTooltipOptions]="{ delayShow: 0, delayHide: 0 }"
                            lgTooltipPosition="right-bottom"
                        ></lg-icon>
                        <lg-icon
                            icon="icon-arrow-right"
                            class="lg-quick-settings-menu-popup__submenu-icon"
                            *ngIf="item.isSubmenu"
                        ></lg-icon>
                    </span>
                </div>
                <div
                    *ngIf="item === 'separator'"
                    class="lg-quick-settings-menu-popup__item lg-quick-settings-menu-popup__separator"
                ></div>
            </ng-container>
        </div>
    </div>
</div>
